import * as _ from 'lodash-es';
import { createSelector, lruMemoize } from 'reselect';

import type { RootState as State } from 'vms/app/rootReducer';

export const selectVehicles = (state: State) => state.vehicles.entities;
export const selectVehicleInWork = (state: State) => state.vehicles.vehicleInWork;
export const selectVehicleCounts = (state: State) => state.vehicles.meta.counts;
export const selectVehicleBuyers = (state: State) => state.vehicles.meta.buyers;
export const selectVehicleSources = (state: State) => state.vehicles.meta.sources;

export const selectByStockNumbers = createSelector(selectVehicles, (vehicles) =>
  _.keyBy(_.values(vehicles), 'stock_number')
);

export const selectVehicle = createSelector(
  [selectVehicles, (_state: State, vehicleId: string) => vehicleId],
  (vehicles, vehicleId) => vehicles[vehicleId],
  { memoize: lruMemoize, memoizeOptions: { maxSize: 200 } }
);
